import * as actions from "../../../actions/inn/edit";

const initialInnEdit = {
	status: "1",
	clientId: "",
	userId: "",
	visitsByMonth: 0,
	displacement: 0,
	errors: {}
};

const initialState = {
	loading: false,
	...initialInnEdit
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.SET_VALUE: {
			return {
				...state,
				...payload
			};
		}
		case actions.CLEAR_VALUE: {
			if (state.item && !payload) {
				return {
					...state,
					...initialInnEdit,
					...state.item,
					item: state.item
				};
			} else {
				return {
					...state,
					...initialInnEdit
				};
			}
		}
		case actions.GET_INN: {
			return {
				...state,
				loading: true
			};
		}
		case actions.EDIT_INN: {
			return {
				...state,
				loading: true
			};
		}
		case actions.GET_INN_FAILED: {
			return {
				...state,
				loading: false
			};
		}
		case actions.EDIT_INN_FAILED: {
			return {
				...state,
				loading: false
			};
		}
		case actions.EDIT_INN_SUCCESS: {
			return {
				...state,
				...initialInnEdit,
				loading: false
			};
		}
		case actions.GET_INN_SUCCESS: {
			return {
				...state,
				item: payload,
				...payload,
				moreInfo: payload.moreInfo || "",
				loading: false
			};
		}
		default: {
			return state;
		}
	}
};

export default reducer;
